module.exports = __webpack_public_path__ + "static/media/header.d2590a0f.jpg";